/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 17:54:09
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-12 18:02:50
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/HotTags/index.tsx
 */
import React from 'react';

import { Input } from '@/src/components/Antd';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';

import TagDragContainer from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/HotTags/TagDragContainer';

import { useDispatch } from 'react-redux';

import { getI18nFromGeneral } from '@/src/tools/tools';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { validateHotTags } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/tools';
import { AllTypes, instanceType, randomNumber } from 'src/tools/helper';
import { i18nGet } from 'src/tools/tools';
import {
  ActionType,
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getHotTags,
  getSubmitStamp,
  onCollapseOpen,
  onErrorChange,
  onHotTagsChange,
  onHotTagsTitleChange,
} from '../slice';
import styles from './css.less';

const HotTags = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();

  const { data, collapseOpenDefault } = props;

  const handleOnTitleChange = (e) => {
    _d(onHotTagsTitleChange(e));
  };

  const handleOnChange = (data, index) => {
    if (instanceType(index) === AllTypes.Number) {
      _d(onHotTagsChange({ type: ActionType.modify, index, data }));
    } else {
      const _data = { ...data, draggableId: randomNumber() };
      _d(onHotTagsChange({ type: ActionType.add, index, data: [_data] }));
    }
  };
  const handleOnSort = (from, to) => {
    _d(onHotTagsChange({ type: ActionType.reorder, data: { from, to } }));
  };
  const handleOnDelete = (index) => {
    _d(onHotTagsChange({ type: ActionType.delete, index }));
  };

  return (
    <div className={collapseOpenDefault ? styles.fieldSection1 : ''}>
      <Section bottomBorder={!collapseOpenDefault}>
        <ItemWrapper
          title={getI18n('general.title')}
          rightPart={`${(data.title || '').length}/30`}>
          <Input
            onChange={handleOnTitleChange}
            size='large'
            maxLength={30}
            value={data.title}
          />
        </ItemWrapper>
      </Section>
      <TagDragContainer
        onChange={handleOnChange}
        onSort={handleOnSort}
        onDelete={handleOnDelete}
        data={data.items || []}
        droppableId={'HotTagsDropZones'}
        withoutCollapse={collapseOpenDefault}
      />
    </div>
  );
};
export default ErrorProcessingHOC(HotTags, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.hotTags,
  getContent: getHotTags,
  title: getI18nFromGeneral('general.hOCTitle.hotTags'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  validation: (x, validationProps) => {
    const { isPrimary } = validationProps || {};

    return validateHotTags(x, !isPrimary);
  },
  getSubmitStamp,
});
